export const NavIcon = ({
  icon,
  colour,
  width,
  height,
}: {
  icon: string;
  colour?: string;
  width?: string;
  height?: string;
}) => {
  switch (icon) {
    case "101":
      return (
        <svg
          width={width || "12"}
          height={width || "13"}
          viewBox="0 0 56 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="translate-y-[1px]"
        >
          <path
            d="M36 8V28C36 32.48 37.48 36.64 40 40H16C18.6 36.56 20 32.4 20 28V8H36ZM48 0H8C5.8 0 4 1.8 4 4C4 6.2 5.8 8 8 8H12V28C12 34.64 6.64 40 0 40V48H23.88V76L27.88 80L31.88 76V48H56V40C49.36 40 44 34.64 44 28V8H48C50.2 8 52 6.2 52 4C52 1.8 50.2 0 48 0Z"
            fill={colour}
          />
        </svg>
      );

    case "map":
      return (
        <svg
          width={width || "12"}
          height={height || "12"}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.6562 0C11.8854 0 12 0.114583 12 0.34375V10.4062C12 10.5729 11.9167 10.6771 11.75 10.7188L8 12L4 10.5938L0.4375 11.9688L0.34375 12C0.114583 12 0 11.8854 0 11.6562V1.59375C0 1.42708 0.0833333 1.32292 0.25 1.28125L4 0L8 1.40625L11.5625 0.03125L11.6562 0ZM8 10.6562V2.75L4 1.34375V9.25L8 10.6562Z"
            fill={colour}
          />
        </svg>
      );

    case "deals":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || "12"}
          height={height || "12"}
          viewBox="0 -960 960 960"
          fill={colour}
          aria-label={"Handshake icon"}
        >
          <path d="M475-160q4 0 8-2t6-4l328-328q12-12 17.5-27t5.5-30q0-16-5.5-30.5T817-607L647-777q-11-12-25.5-17.5T591-800q-15 0-30 5.5T534-777l-11 11 74 75q15 14 22 32t7 38q0 42-28.5 70.5T527-522q-20 0-38.5-7T456-550l-75-74-175 175q-3 3-4.5 6.5T200-435q0 8 6 14.5t14 6.5q4 0 8-2t6-4l136-136 56 56-135 136q-3 3-4.5 6.5T285-350q0 8 6 14t14 6q4 0 8-2t6-4l136-135 56 56-135 136q-3 2-4.5 6t-1.5 8q0 8 6 14t14 6q4 0 7.5-1.5t6.5-4.5l136-135 56 56-136 136q-3 3-4.5 6.5T454-180q0 8 6.5 14t14.5 6Zm-1 80q-37 0-65.5-24.5T375-166q-34-5-57-28t-28-57q-34-5-56.5-28.5T206-336q-38-5-62-33t-24-66q0-20 7.5-38.5T149-506l232-231 131 131q2 3 6 4.5t8 1.5q9 0 15-5.5t6-14.5q0-4-1.5-8t-4.5-6L398-777q-11-12-25.5-17.5T342-800q-15 0-30 5.5T285-777L144-635q-9 9-15 21t-8 24q-2 12 0 24.5t8 23.5l-58 58q-17-23-25-50.5T40-590q2-28 14-54.5T87-692l141-141q24-23 53.5-35t60.5-12q31 0 60.5 12t52.5 35l11 11 11-11q24-23 53.5-35t60.5-12q31 0 60.5 12t52.5 35l169 169q23 23 35 53t12 61q0 31-12 60.5T873-437L545-110q-14 14-32.5 22T474-80Zm-99-560Z" />
        </svg>
      );

    case "stats":
      return (
        <svg
          width={width || "11"}
          height={height || "12"}
          viewBox="0 0 11 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.17188 11.3438V0.65625H6.82812V11.3438H4.17188ZM0.171875 11.3438V6H2.82812V11.3438H0.171875ZM8.17188 4H10.8281V11.3438H8.17188V4Z"
            fill={colour}
          />
        </svg>
      );

    case "trends":
      return (
        <svg
          width={width || "12"}
          height={height || "8"}
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.67188 0H13.6719V4L12.1406 2.46875L7.92188 6.65625L5.26562 4L1.26562 8L0.328125 7.0625L5.26562 2.125L7.92188 4.78125L11.2031 1.53125L9.67188 0Z"
            fill={colour}
          />
        </svg>
      );

    case "successes":
      return (
        <svg
          width={width || "13"}
          height={height || "13"}
          viewBox="0 0 79 104"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54.0162 86.6749L39.5 78.1064L24.9838 86.6749L28.835 70.1323L16.0469 59.038L32.8838 57.6016L39.5 42.0992L46.1162 57.6016L62.9531 59.038L50.165 70.1323M78.9999 0H5.84133e-05V9.9057L23.9963 27.9341C15.6243 31.5179 8.74316 37.8921 4.51656 45.9788C0.289962 54.0655 -1.02268 63.3684 0.800618 72.314C2.62392 81.2597 7.47127 89.2992 14.5229 95.0729C21.5745 100.847 30.3976 104 39.5 104C48.6024 104 57.4255 100.847 64.4771 95.0729C71.5287 89.2992 76.3761 81.2597 78.1994 72.314C80.0227 63.3684 78.71 54.0655 74.4834 45.9788C70.2568 37.8921 63.3757 31.5179 55.0037 27.9341L78.9999 9.9057M69.125 64.387C69.1276 70.0148 67.5371 75.5277 64.5385 80.2842C61.5398 85.0407 57.2564 88.8453 52.1865 91.2553C47.1166 93.6654 41.4687 94.5818 35.9 93.8979C30.3312 93.214 25.0705 90.9579 20.7299 87.3922C16.3894 83.8265 13.1474 79.0977 11.3813 73.756C9.61511 68.4144 9.39737 62.6794 10.7534 57.2185C12.1094 51.7576 14.9834 46.7951 19.041 42.9085C23.0986 39.022 28.173 36.3711 33.6738 35.2643C37.5177 34.4716 41.4823 34.4716 45.3262 35.2643C52.0359 36.6143 58.0727 40.2529 62.4111 45.5618C66.7494 50.8706 69.1217 57.5224 69.125 64.387ZM42.6106 24.7642H36.3894L16.6394 9.9057H62.7556L42.6106 24.7642Z"
            fill={colour}
          />
        </svg>
      );

    case "facts":
      return (
        <svg
          width={width || "13"}
          height={height || "13"}
          viewBox="0 0 1024 1024"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
            fill={colour}
          ></path>
        </svg>
      );

    case "our-take":
      return (
        <svg
          width={width || "12"}
          height={height || "12"}
          viewBox="0 0 65 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M61.921 14.1341C60.7323 15.3229 59.5784 16.4767 59.5435 17.6305C59.4386 18.7494 60.6274 19.9032 61.7462 20.9871C63.4245 22.7353 65.0678 24.3086 64.9978 26.0219C64.9279 27.7351 63.1448 29.5182 61.3616 31.2664L46.9215 45.7415L41.9566 40.7766L56.8163 25.9519L53.4598 22.5954L48.4949 27.5253L35.3834 14.4139L48.8096 1.02269C50.1732 -0.340898 52.4458 -0.340898 53.7395 1.02269L61.921 9.20424C63.2846 10.4979 63.2846 12.7706 61.921 14.1341ZM0 49.8323L33.4255 16.3718L46.5369 29.4833L13.1115 62.9437H0V49.8323Z"
            fill={colour}
          />
        </svg>
      );

    case "stars":
      return (
        <svg
          width={width || "14"}
          height={height || "13"}
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.98438 10.5L2.85938 13L3.95312 8.3125L0.328125 5.15625L5.10938 4.75L6.98438 0.34375L8.85938 4.75L13.6719 5.15625L10.0156 8.3125L11.1094 13L6.98438 10.5Z"
            fill={colour}
          />
        </svg>
      );

    case "startups":
      return (
        <svg
          width={width || "13"}
          height={height || "13"}
          viewBox="0 0 88 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44 8C59.16 8 72.68 16.52 79.28 30C72.68 43.48 59.2 52 44 52C28.8 52 15.32 43.48 8.72 30C15.32 16.52 28.84 8 44 8ZM44 0C24 0 6.92 12.44 0 30C6.92 47.56 24 60 44 60C64 60 81.08 47.56 88 30C81.08 12.44 64 0 44 0ZM44 20C49.52 20 54 24.48 54 30C54 35.52 49.52 40 44 40C38.48 40 34 35.52 34 30C34 24.48 38.48 20 44 20ZM44 12C34.08 12 26 20.08 26 30C26 39.92 34.08 48 44 48C53.92 48 62 39.92 62 30C62 20.08 53.92 12 44 12Z"
            fill={colour}
          />
        </svg>
      );

    case "incumbents":
      return (
        <svg
          width={width || "14"}
          height={height || "13"}
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.3281 3C12.7031 3 13.0156 3.13542 13.2656 3.40625C13.5365 3.65625 13.6719 3.96875 13.6719 4.34375V11.6562C13.6719 12.0312 13.5365 12.3542 13.2656 12.625C13.0156 12.875 12.7031 13 12.3281 13H1.67188C1.29688 13 0.973958 12.875 0.703125 12.625C0.453125 12.3542 0.328125 12.0312 0.328125 11.6562V4.34375C0.328125 3.96875 0.453125 3.65625 0.703125 3.40625C0.973958 3.13542 1.29688 3 1.67188 3H4.32812V1.65625C4.32812 1.30208 4.45312 1 4.70312 0.75C4.97396 0.479167 5.29688 0.34375 5.67188 0.34375H8.32812C8.70312 0.34375 9.01562 0.479167 9.26562 0.75C9.53646 1 9.67188 1.30208 9.67188 1.65625V3H12.3281ZM8.32812 3V1.65625H5.67188V3H8.32812Z"
            fill={colour}
          />
        </svg>
      );
    case "sources":
      return (
        <svg
          width={width || "13"}
          height={height || "13"}
          viewBox="0 0 88 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M80 2C75.56 0.6 70.68 0 66 0C58.2 0 49.8 1.6 44 6C38.2 1.6 29.8 0 22 0C14.2 0 5.8 1.6 0 6V64.6C0 65.6 1 66.6 2 66.6C2.4 66.6 2.6 66.4 3 66.4C8.4 63.8 16.2 62 22 62C29.8 62 38.2 63.6 44 68C49.4 64.6 59.2 62 66 62C72.6 62 79.4 63.2 85 66.2C85.4 66.4 85.6 66.4 86 66.4C87 66.4 88 65.4 88 64.4V6C85.6 4.2 83 3 80 2ZM80 56C75.6 54.6 70.8 54 66 54C59.2 54 49.4 56.6 44 60V14C49.4 10.6 59.2 8 66 8C70.8 8 75.6 8.6 80 10V56Z"
            fill={colour}
          />
          <path
            d="M64 24C67.52 24 70.92 24.36 74 25.04V18.96C70.84 18.36 67.44 18 64 18C57.2 18 51.04 19.16 46 21.32V27.96C50.52 25.4 56.8 24 64 24Z"
            fill={colour}
          />
          <path
            d="M46 31.9596V38.5996C50.52 36.0396 56.8 34.6396 64 34.6396C67.52 34.6396 70.92 34.9996 74 35.6796V29.5996C70.84 28.9996 67.44 28.6396 64 28.6396C57.2 28.6396 51.04 29.8396 46 31.9596Z"
            fill={colour}
          />
          <path
            d="M64 39.3203C57.2 39.3203 51.04 40.4803 46 42.6403V49.2803C50.52 46.7203 56.8 45.3203 64 45.3203C67.52 45.3203 70.92 45.6803 74 46.3603V40.2803C70.84 39.6403 67.44 39.3203 64 39.3203Z"
            fill={colour}
          />
        </svg>
      );
    case "feedback":
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ml-[-3px]"
        >
          <path
            d="M16 8.15625V9.84375C16 10.0938 15.9583 10.3229 15.875 10.5312L12.8125 17.5938C12.4792 18.4271 11.875 18.8438 11 18.8438H2C1.45833 18.8438 0.979167 18.6562 0.5625 18.2812C0.1875 17.8646 0 17.3854 0 16.8438V8.15625C0 7.61458 0.1875 7.13542 0.5625 6.71875L7.1875 0.15625L8.25 1.21875C8.54167 1.51042 8.6875 1.86458 8.6875 2.28125L8.625 2.59375L7.75 6.84375H14.6875C15.0208 6.84375 15.3125 6.96875 15.5625 7.21875C15.8542 7.46875 16 7.78125 16 8.15625ZM30 13.4688C30.5417 13.4688 31 13.6771 31.375 14.0938C31.7917 14.4688 32 14.9271 32 15.4688V24.1562C32 24.6979 31.8125 25.1771 31.4375 25.5938L24.8125 32.1562L23.75 31.0938C23.4583 30.8021 23.3125 30.4479 23.3125 30.0312L23.375 29.7188L24.25 25.4688H17.3125C16.9792 25.4688 16.6667 25.3438 16.375 25.0938C16.125 24.8438 16 24.5312 16 24.1562V22.4688C16 22.2188 16.0417 21.9896 16.125 21.7812L19.1875 14.7188C19.5208 13.8854 20.125 13.4688 21 13.4688H30Z"
            fill={colour}
          />
        </svg>
      );

    default:
      return null;
  }
};
